<template>
  <div>

    <div class="iaa-programs-container">
      <div class="container-fluid">
        <div class="black-line"></div>
        <div class="ipc-header mb-3 d-flex justify-content-between align-items-center">
          <p class="head-title mb-0">Sectors we work in </p>
          <div class="ipc-arrow">
            <button class="swiperPrev" slot="button-prev" @click="prev()">
              <span class="icon-arrow-left icon"></span>
              </button>
            <button class="swiperNext" slot="button-next" @click="next()">
              <span class="icon-arrow-right icon"></span>
            </button>
          </div>
        </div>
        <swiper ref="mySwiper" :options="swiperOptions">
          <!-- <swiper-slide v-for="(row, index) in rows" :key="index">
              <div class="col-md-6">
                <div class="over-h">
                    <div class="img-h">
                      <img class="d-block w-100" 
                        :src="row.image">
                    </div>
                    <div class="sector-content">
                      <p>{{ row.title }}</p>
                      <router-link :to="{name: 'sector-programs', params: {slug: row.slug } }" 
                          class="btn-primary btn-black-o">Read More
                        <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                      </router-link>
                    </div>
                  </div>
              </div>
          </swiper-slide>       -->

          <swiper-slide  v-for="(row, index) in rows" :key="index">
              <div>
                <div class="over-h">
                    <div class="img-h">
                      <img class="d-block w-100" 
                        :src="row.image">
                    </div>
                    <div class="sector-content d-flex align-items-center justify-content-between">
                      <p v-html="row.title"></p>
                      <router-link :to="row.redirect"
                          class="d-inline-block bk-btn">
                        <div class="d-flex align-items-center">
                          Read More
                          <span class="icon-arrow-right icon ml-2"></span>
                        </div>
                      </router-link>
                    </div>
                  </div>
              </div>
          </swiper-slide>     
        </swiper>
      </div>
    </div>
    
    <!-- Sectors Cards -->
      <!-- <div class="sectors sec-mb">
      <div class="container-fluid">
        <div class="black-line"></div>
        <p class="head-title">Sectors we work in </p>
        <div id="carouselExampleControls" class="carousel carousel-iaamc-container slide" data-ride="carousel" data-interval="false">
          
          <div class="carousel-inner" v-if="!pgLoading">

            <div class="carousel-item active">
              <div class="row">

                <div v-if="sectors[0]" class="col-md-6">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[0].image" 
                          :src="sectors[0].image" 
                          :alt="sectors[0].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[0].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[0].slug } }" 
                            class="btn-primary btn-black-o">Read More
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

                <div v-if="sectors[1]" class="col-md-6 sec">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[1].image" 
                          :src="sectors[1].image" 
                          :alt="sectors[1].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[1].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[1].slug } }" 
                            class="btn-primary btn-black-o">Read More 
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

              </div>
            </div>

            <div class="carousel-item" v-if="sectors[2]">
              <div class="row">

                <div v-if="sectors[2]" class="col-md-6">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[2].image" 
                          :src="sectors[2].image" 
                          :alt="sectors[2].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[2].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[2].slug } }" 
                            class="btn-primary btn-black-o">Read More
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

                <div v-if="sectors[3]" class="col-md-6 sec">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[3].image" 
                          :src="sectors[3].image" 
                          :alt="sectors[3].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[3].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[3].slug } }" 
                            class="btn-primary btn-black-o">Read More 
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

              </div>
            </div>

            <div class="carousel-item" v-if="sectors[4]">
              <div class="row">

                <div v-if="sectors[4]" class="col-md-6">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[4].image" 
                          :src="sectors[4].image" 
                          :alt="sectors[4].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[4].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[4].slug } }" 
                            class="btn-primary btn-black-o">Read More
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

                <div v-if="sectors[5]" class="col-md-6 sec">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[5].image" 
                          :src="sectors[5].image" 
                          :alt="sectors[5].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[5].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[5].slug } }" 
                            class="btn-primary btn-black-o">Read More 
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

              </div>
            </div>

            <div class="carousel-item" v-if="sectors[6]">
              <div class="row">

                <div v-if="sectors[6]" class="col-md-6">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[6].image" 
                          :src="sectors[6].image" 
                          :alt="sectors[6].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[6].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[6].slug } }" 
                            class="btn-primary btn-black-o">Read More
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

                <div v-if="sectors[7]" class="col-md-6 sec">
                  <div class="over-h">
                      <div class="img-h">
                        <img class="d-block w-100" 
                          v-if="sectors[7].image" 
                          :src="sectors[7].image" 
                          :alt="sectors[7].title">
                      </div>
                      <div class="sector-content">
                        <p>{{ sectors[7].title }}</p>
                        <router-link :to="{name: 'sector-programs', params: {slug: sectors[7].slug } }" 
                            class="btn-primary btn-black-o">Read More 
                          <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon"> 
                        </router-link>
                      </div>
                    </div>
                </div>

              </div>
            </div>

          </div>

            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
              <img src="../../assets/images/icons/arrow-left-b.svg" alt="" class="svg-icon">
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
              <img src="../../assets/images/icons/arrow-right-b.svg" alt="" class="svg-icon">
            </a>

      </div>
    </div>
    </div> -->

    <div class="container-fluid">
      <hr>
    </div>
    <!-- Sectors Cards -->

  </div>
</template>

<style scoped>
.icon-arrow-right.icon {
  font-weight: bold;
}
.img-h {
  overflow: hidden;
}
.swiper-slide .over-h img {
  height: 280px;
  object-fit: cover;
} 
.sector-content {
  padding: 22px 0
}
.sector-content p {
  font-weight: bold;
  font-size: 30px;
  line-height: 1;
  text-transform: capitalize;
  color: #000;
  margin-bottom: 0;
}
.over-h {
  overflow: visible;
}
.bk-btn {
  border: 1px solid #000;
  padding: 5px 15px;
  font-size: 14px;
}
.bk-btn:hover {
  background: #000;
  color: #fff;
}
.bk-btn:active {
  opacity: 0.5;
}
.ipc-arrow button {
  margin-left: 15px;
}
.ipc-arrow .icon {
  font-size: 36px;
  font-weight: bold;
}
.ipc-arrow .icon:active {
  opacity: 0.5;
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {}

@media (max-width: 767.98px) { 
  .ipc-header {
    display: block !important;
  }
  .ipc-arrow {
    margin-bottom: 13px;
    display: flex;
    justify-content: flex-end;
  }
  .ipc-arrow button {
    
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) { 

 }

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) { 

 }

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) { 

 }

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) { 

 }
</style>

<script>
import axios from "axios";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: "Section2",
  props: ['row'],
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      pgLoading: true,
      sectors: [],
      rows: [],
      swiperOptions: {
        loop: false,
        spaceBetween: 30,
        speed: 700,
        autoplay: {
          delay: 5000
        },
        // slidesPerView: 3,
        navigation: {
            nextEl: '.swiperNext',
            prevEl: '.swiperPrev'
        },
        breakpoints: {
          767: {
            slidesPerView: 1
          },
          800: {
            slidesPerView: 2
          },
          1200: {
            slidesPerView: 2
          }
        }
      }
    };
  },
  created() {
      //
      this.fetchSectors();
      this.fetchSlider();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    //

    prev() {
			this.$refs.mySwiper.$swiper.slidePrev();
		},
		next() {
			this.$refs.mySwiper.$swiper.slideNext();
		},
    fetchSlider() {
      axios
        .get(window.baseURL + "/sectorsInHome")
        .then((res) => {
          this.pgLoading = false;
          const data = res.data.row;
          this.rows = data;
          console.log(data);
        })
        .catch(() => {});
    },

    fetchSectors() {
        axios
        .get(window.baseURL + "/programs")
        .then((res) => {
          this.pgLoading = false;
          var data = res.data.rows;
          // Get Sectors
          for (var i = 0; i < data.length; i++) {
            if (data[i].sectors != "") {
              this.sectors = data[i].sectors;
            }
          }

        })
        .catch(() => {});
    },

  },
};
</script>
